import { FC, useState } from 'react';
import { defaultTimePreset, defaultTimezone } from '../constants';
import { DateParams } from '../types';
import { TimeFiltersContext } from './TimeFiltersContext';
import { useUrlParamsContext } from './UrlParamsContext';

export const TimeFiltersContextProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const {
    exportUrlCAFFOn: FF,
    startTimeParam,
    endTimeParam,
    timezoneParam,
    timePresetParam,
  } = useUrlParamsContext();
  const dateRange =
    FF && startTimeParam
      ? {
          startTime: startTimeParam,
          endTime: endTimeParam,
        }
      : undefined;
  const [dateParams, setDateParams] = useState<DateParams | undefined>(dateRange);
  const [timezone, setTimezone] = useState(FF && timezoneParam ? timezoneParam : defaultTimezone);
  const [timePreset, setTimePreset] = useState(
    FF && timePresetParam ? timePresetParam : defaultTimePreset,
  );

  return (
    <TimeFiltersContext.Provider
      value={{ dateParams, setDateParams, timezone, setTimezone, timePreset, setTimePreset }}
    >
      {children}
    </TimeFiltersContext.Provider>
  );
};
